import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import type { FormResponse } from "@tellescope/types-models";
import { useFormAccessCodeIframe } from "./useFormAccessCodeIframe";

interface FormAccessCodeIframeProps {
  formResponse: Pick<FormResponse, "formId" | "formTitle" | "accessCode" | "automationStepId">;
  onSubmitted: () => void;
}

export const FormAccessCodeIframe = ({ formResponse, onSubmitted }: FormAccessCodeIframeProps) => {
  const { t } = useTranslation("forms");
  const { iframeRef, iframeUrl, isLoading, error } = useFormAccessCodeIframe({ formResponse, onSubmitted });

  if (isLoading) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <div className="text-center text-muted-foreground">
          <Loader2 className="h-8 w-8 mx-auto mb-2 animate-spin" />
          <p className="text-sm">{t("Loading form...")}</p>
        </div>
      </div>
    );
  }

  if (error || !iframeUrl) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <div className="text-center text-destructive">
          <p className="text-sm font-medium mb-1">{t("Unable to load form")}</p>
          {error && <p className="text-xs text-muted-foreground">{error.message}</p>}
        </div>
      </div>
    );
  }

  return (
    <iframe
      ref={iframeRef}
      src={iframeUrl}
      className="flex-1 w-full border-0"
      title={formResponse.formTitle}
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
    />
  );
};
